import LinkWithRetainedParams from './LinkWithRetainedParams';

export default LinkWithRetainedParams;
